<template>
  <div class="row">
    <div class="col">
      <h5>Profile</h5>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <location-host v-if="!loading.location" :isProfile="true" ref="host" :firm="selectedFirm" />
    </div>
  </div>
  <div class="row mt-4">
    <div class="col text-center">
      <router-link to="/extension">Get the Invoices AI Chrome Extension Here</router-link>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col text-center">
      <p>
        By using this service, you agree to our <router-link to="/terms-of-service">Terms of Service</router-link> and
        <router-link to="/privacy-policy">Privacy Policy</router-link>.
      </p>
      <p class="custom-copyright">© 2025 Jingle Enterprises. All rights reserved.</p>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import LocationHost from '@/components/locations/forms/LocationHost.vue'
export default {
  name: 'ProfileView',
  components: {
    LocationHost
  },
  data() {
    return {
      selectedFirm: null
    }
  },
  mounted() {
    this.loadLocation()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['loading', 'location'])
  },
  methods: {
    ...mapActions(locationStore, ['getLocation']),
    async loadLocation() {
      await this.getLocation(this.profile.firm)
      console.log('Loaded Firm', this.location)

      this.selectedFirm = {
        parent: this.location.firm,
        id: this.location.firm,
        firm: this.location.firm,
        name: this.location.firmName,
        type: this.location.firmType,
        typeName: this.location.firmTypeName,
        contact: this.location.contact,
        firmClass: this.location.firmClass
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-checkbox-wrapper {
  border: 1px solid #ccc;
  padding: 10px;
  padding-left: 40px;
  padding-bottom: 15px;
}
</style>
